import React from 'react';
import { Omit } from '../../../../ui';
import {
	IShowMoreButtonProps,
	ShowMoreButton,
} from '../../../shared/components';
import { withTranslate } from '../../../shared/i18n/translate';

type IFlightsNavigationButtonProps = Omit<IShowMoreButtonProps, 'title'>;

export const FlightsNavigationButton =
	withTranslate<IFlightsNavigationButtonProps>(
		({ t, direction, absolutePositioning, ...rest }) => (
			<ShowMoreButton
				{...rest}
				direction={direction}
				absolutePositioning={absolutePositioning}
				title={
					direction === 'up'
						? t('flight_list_earlier_flights')
						: t('flight_list_later_flights')
				}
			/>
		),
	);
